import { Check } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { PARTNER, IMG } from "@/lib/content";
import { PageHero, SectionTitle, IconCards, Reveal } from "@/components/kit";
import { DynamicForm } from "@/components/forms/DynamicForm";
import { PARTNER_FIELDS } from "@/components/forms/configs";

export default function PartnerPage({ ong = false }) {
  useSeo(ong ? "Recrutement partenaire étranger" : "Devenir partenaire",
    "Rejoignez MA LEBA pour sauver des vies et améliorer la santé des plus vulnérables : ONG, fondations, entreprises, institutions, bailleurs, donateurs.");
  return (
    <div data-testid={ong ? "foreign-partners-page" : "partner-page"}>
      <PageHero eyebrow={ong ? "ONG MA LEBA" : "Partenariat"} title={ong ? "Recrutement partenaire étranger" : "Devenir partenaire"}
        intro="Rejoignez-nous pour sauver des vies et améliorer la santé des plus vulnérables." image={IMG.health2} />

      <section className="container-x grid gap-12 py-16 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <SectionTitle eyebrow="Qui peut devenir partenaire ?" title="Toutes les bonnes volontés" />
          <ul className="mt-8 flex flex-wrap gap-2" data-testid="partner-who">
            {PARTNER.who.map((w) => (
              <li key={w} className="rounded-full border-2 border-u bg-white px-4 py-2 font-display font-semibold uppercase tracking-wide text-u">{w}</li>
            ))}
          </ul>
          <h3 className="mt-14 font-display text-2xl font-bold uppercase text-ink">Domaines de partenariat</h3>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-testid="partner-domains">
            {PARTNER.domains.map((d) => (
              <li key={d} className="flex items-start gap-3"><Check className="mt-0.5 h-5 w-5 shrink-0 text-u" aria-hidden="true" />{d}</li>
            ))}
          </ul>
        </div>
        {ong && (
          <div className="grid grid-cols-2 gap-4 lg:col-span-5">
            {["/assets/affiche-partenaire-1.webp", "/assets/affiche-partenaire-2.webp"].map((src, i) => (
              <Reveal key={src} delay={i * 0.1}>
                <a href={src} target="_blank" rel="noopener noreferrer" data-testid={`partner-poster-${i}`}>
                  <img src={src} alt="Affiche recrutement partenaire étranger ONG MA LEBA" loading="lazy" className="rounded-xl shadow-lg transition-transform hover:-translate-y-1" />
                </a>
              </Reveal>
            ))}
          </div>
        )}
      </section>

      <section className="bg-white py-16">
        <div className="container-x">
          <SectionTitle eyebrow="Pourquoi nous rejoindre ?" title="Un partenariat qui a du sens" className="mb-10" />
          <IconCards items={PARTNER.why} cols="lg:grid-cols-4" testid="partner-why" />
        </div>
      </section>

      <section className="pagne py-16" id="candidature">
        <div className="container-x max-w-4xl">
          <SectionTitle eyebrow="Candidature" title="Formulaire de candidature partenaire" className="mb-8" />
          <div className="card p-6 sm:p-10">
            <DynamicForm fields={PARTNER_FIELDS} endpoint="/applications/partenaire" testid="partner-form" submitLabel="Envoyer ma candidature"
              initial={{ structure: ong ? "ong" : "les_deux" }} />
          </div>
        </div>
      </section>
    </div>
  );
}
